module.exports = __webpack_public_path__ + "img/img10.2e4ab764.svg";